export default function (value){
    var formatter = new Intl.NumberFormat('tr-TR', {});
    return formatter.format(value)
}
